import { Button, Flex, Popover, PopoverBody, PopoverContent, PopoverTrigger, Tag, Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

import { formatDate, roleCheck } from '@helpers/utils';
import { MoreIcon, EyeIcon, TrashcanIcon, CheckMarkIcon, DoubleCheckMarkIcon } from '@assets/icons.js';
import { usePromotionClaim } from '@pages/ConsumerPromotion/hooks/state/usePromotionClaim';
import { STATUS } from '../../utils/const';
import { useConfirmModal } from '@store/useConfirmModal';
import useMutateCPList from '@pages/ConsumerPromotion/hooks/mutate/useMutateCPList';

const renderComp = (value) => {
    return (
        <Flex h={'40px'} alignItems={'center'}>
            <Text>{value ?? '-'}</Text>
        </Flex>
    );
};

export const tableList = [
    {
        name: 'Customer Promotion Name',
        value: 'promotion_name',
        withSort: true,
        width: 311,
        component: ({ value }) => renderComp(value),
    },
    {
        name: 'Scheme',
        value: 'scheme_name',
        withSort: true,
        width: 88,
        component: ({ value }) => renderComp(value ? `${value}%` : '-'),
    },
    {
        name: 'Start Date',
        value: 'start_date',
        withSort: true,
        width: 100,
        component: ({ value }) => renderComp(formatDate(value)),
    },
    {
        name: 'End Date',
        value: 'end_date',
        withSort: true,
        width: 94,
        component: ({ value }) => renderComp(formatDate(value)),
    },
    {
        name: 'Customer Count',
        value: 'customer_count',
        withSort: true,
        width: 134,
        component: ({ value }) => renderComp(value),
    },
    {
        name: 'Status',
        value: 'status',
        withSort: true,
        width: 136,
        component: ({ value }) => {
            const normalizedValue = value?.toLowerCase?.() === 'reject' ? 'Declined' : value;
            const variant = STATUS[value?.toLowerCase?.()] || 'draft';
            const tagValue =
                value.toLowerCase() === 'done' ? (
                    <Flex gap={'4px'} alignItems={'center'}>
                        <DoubleCheckMarkIcon /> {value}
                    </Flex>
                ) : value.toLowerCase() === 'ready to claim' ? (
                    <Flex gap={'4px'} alignItems={'center'}>
                        <CheckMarkIcon /> {value}
                    </Flex>
                ) : (
                    normalizedValue
                );

            return (
                <Flex h={'40px'} alignItems={'center'}>
                    <Tag variant={variant} textTransform={'capitalize'} w={'fit-content'} maxW={'fit-content'}>
                        {tagValue ?? '---'}
                    </Tag>
                </Flex>
            );
        },
    },
    {
        name: 'Action',
        value: 'id',
        width: 57,
        sortable: false,
        component: (props) => {
            const navigate = useNavigate();
            const state = usePromotionClaim();
            const stateConfirm = useConfirmModal();
            const { deleteCP } = useMutateCPList();

            const role = roleCheck();
            const isAdmin = role === 'Area Admin';
            const isHideDelete = ['active', 'ready to claim', 'done'].includes(props?.values?.status?.toLowerCase?.());

            const hanldeView = () => {
                state.set({ row_id: props.value });
                navigate(`detail/${props.value}`);
            };

            const hanldeDelete = () => {
                stateConfirm.set({
                    isOpen: true,
                    title: 'Hapus Promotion Claim?',
                    desc: 'Data yang telah dituliskan akan hilang, perlu melakukan pengisian ulang untuk membuat promotion claim.',
                    onSubmit: () => {
                        deleteCP.mutate(props.value);
                    },
                });
            };
            return (
                <Popover placement="bottom-start">
                    <PopoverTrigger>
                        <Button variant={'unstyled'}>
                            <MoreIcon />
                        </Button>
                    </PopoverTrigger>
                    <PopoverContent>
                        <PopoverBody w={'full'} _hover={{ bg: 'sagitarius.100' }}>
                            <Button variant={'unstyled'} onClick={hanldeView} color={'sagitarius.500'}>
                                <EyeIcon size={18} />
                                View
                            </Button>
                        </PopoverBody>
                        {isAdmin && !isHideDelete && (
                            <PopoverBody _hover={{ bg: 'danger.100' }}>
                                <Button variant={'unstyled'} onClick={hanldeDelete} color={'danger.500'}>
                                    <TrashcanIcon size={18} />
                                    Delete
                                </Button>
                            </PopoverBody>
                        )}
                    </PopoverContent>
                </Popover>
            );
        },
    },
];
